import ApiService from '@/services/ApiService'

interface IVerificacaoAssinatura {
  tem_assinatura_ativa: boolean
  fornecedores: Array<{
    id: string
    nome_fantasia: string
    plano_id: string | null
    tem_assinatura_ativa: boolean
  }>
}

class AssinaturaStatusService extends ApiService {
  constructor() {
    super('fornecedor', 'admin')
  }

  async verificarAssinatura(): Promise<IVerificacaoAssinatura> {
    const response = await this.getOrDeleteRequest('GET', {}, 'verificar-assinatura')

    return response.data as IVerificacaoAssinatura
  }

  async verificarAssinaturaAtiva(): Promise<boolean> {
    try {
      const result = await this.verificarAssinatura()

      return result.tem_assinatura_ativa
    }
    catch (error) {
      console.error('Erro ao verificar assinatura:', error)

      return false
    }
  }
}

// Factory function para evitar problemas de inicialização
export const createAssinaturaStatusService = () => new AssinaturaStatusService()

export default createAssinaturaStatusService
